module.exports = __webpack_public_path__ + "media/images/smart_phone/customer_code_sample-cb66843acf1d93deb4fa1abc28f634fe.jpg";